export default "__VITE_ASSET__EWfux8TK__"